export default __webpack_public_path__ + "static/media/ly.02815876.svg";